module.exports = "https://static.wmbcdn.com/uniweb/images/1b3b7fed877d2bfb20e6742b37e5bc71.svg";